export const Messages = {
  titleNewVersion: 'PMM 3 is here and it’s better',
  viewMigrationGuide: 'View migration guide',
  close: 'Close',
  description:
    'Upgrade for enhanced security, improved stability, and a smoother experience. PMM 3 also sets the foundation for exciting future updates. ',
  seeWhatsNew: 'See what’s new in PMM 3',
};
